import http from '@/environment/environment';

class GameReleaseService
{
    getReleasesList(gameId: string, userId: string, jwtToken: string): Promise<any> {
        http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
        return http.get(`games/${gameId}/releases?userId=${userId}&platform=Any`);
    }
}

export default new GameReleaseService();